import * as React from "react";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { Menu } from "@material-ui/core";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { DataEquipment as DataRow } from "../List/ListTableHotel";
// import { RouteAdmin } from '../../constant/routesName';

export const ContextMenuEquipment = (props: {
    open: boolean;
    anchorEl: null | HTMLElement;
    handleClose: () => void;
    handleDeleteRow: (rowId: string) => void;
    row?: DataRow;
}) => {
    const history = useHistory();

    const handleEdit = () => {
        if (props.row) {
            history.push(`modif/hotel/${props.row._id}`);
            props.handleClose();
        }
    };

    const handleDeleteRow = () => {
        if (props.row) {
            props.handleDeleteRow(props.row._id);
            props.handleClose();
        }
    };

    const { t } = useTranslation();

    return (
        <Paper sx={{ width: 320, maxWidth: "100%" }}>
            <Menu
                id="cotenxt-menu-table"
                anchorEl={props.anchorEl}
                open={props.open}
                onClose={props.handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                <MenuList>
                    <Divider />
                    <MenuItem onClick={handleEdit}>
                        <ListItemIcon>
                            <Edit fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{t("contextMenu.editer")}</ListItemText>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleDeleteRow}>
                        <ListItemIcon>
                            <Delete fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>
                            {t("contextMenu.supprimer")}
                        </ListItemText>
                    </MenuItem>
                </MenuList>
            </Menu>
        </Paper>
    );
};
